/*
* @Author: chillylight
* @Date:   2019-10-17 09:27:38
* @Last Modified by:   chillylight
* @Last Modified time: 2020-08-25 14:40:43
*/
import 'select2/dist/css/select2.min.css';
import _comMeds from '@src/assets/js/common.js';
import _term from '@src/assets/js/server/term-server.js';
import _tran from '@src/assets/js/server/tran-server.js';
import FormData from 'form-data';
import '@src/assets/js/table.js';
import 'jquery-form';
import './index.scss';
import 'select2';

// const fromLan = require("@src/assets/json/lan.json");
const indstryList = require("@src/assets/json/indstry.json");
var fromLan = '';
var toLan = '';

var page = {
    data: {
       inIds: [],  //已选行业库ids
       libraryId: '',
       industryId: '',
       industryName: '',
       leftName: '',
       rightName: '',
       lanCreateTime: '',
       currId: '',  // 当前选择的行业id
       leftId: '',  //原文id
       rightId: '', //译文id
       selectionIds: [], //保存选中ids
       importType: 0,  //导入文件时是否覆盖
       formData: null,
       ss: 0,
       initFromVal:1,
       initToVal:2
    },
    init: function() {
       this.onLoad();
       this.bindEvent();
    },
    onLoad: function() {
        this.getMyIndustryList(); 
        this.getLanOptions();
    },
    bindEvent: function() {
        var _this = this;

        // 未登录状态显示空状态
        if(!_comMeds.isLogin()){
            _this.showEmptyKu();
        }

        // 点击行业头部
        $('body').on('click', '.toggle-head', function(){
            if($(this).hasClass('active')){
                return;
            } else {
                $(this).siblings().removeClass("active");
                $(this).siblings().children('.caret').removeClass('active');
                $(this).parent().find('.toggle-head').next().slideUp("200");
                $(this).addClass("active");
                $(this).next().slideDown("200");
                
                $(this).children('.caret').addClass('active');
                $(this).children('.showdown').hide();
                $(this).children('.delwhat').show(); 

                $(this).siblings().children('.showdown').show();
                $(this).siblings().children('.delwhat').hide();
                $(this).siblings().children('.okdel').hide();
                $(this).siblings().children(".caret").show();
                $(this).siblings().children(".del").hide();
                $(this).siblings().next(".toggle-body").find(".del").hide();
                $(this).siblings().next(".toggle-body").find("a.active").removeClass('dot');

                
                $(this).next('.toggle-body').children('dd').find('a').removeClass('active');
                $(this).next('.toggle-body').children('dd:first-child').find('a').addClass('active');
                _this.data.industryId = $(this).next('.toggle-body').children('dd:first-child').data('industryid');
                _this.data.libraryId =  $(this).next('.toggle-body').children('dd:first-child').data('id');
                _this.data.leftName = $(this).next('.toggle-body').children('dd:first-child').data('from');
                _this.data.rightName = $(this).next('.toggle-body').children('dd:first-child').data('to');
                _this.data.lanCreateTime = $(this).next('.toggle-body').children('dd:first-child').data('time');
                _this.data.industryName = $(this).children('.libraryName').text();

                _this.loadRight();
                $('.choosenum').hide();
                $('.delWord').addClass('active');
                $('.daochu').addClass('active');
                _this.data.selectionIds = [];
            }
        })

        // 左侧语言切换
        $('body').on('click', '.toggle-body dd', function(e){
            $(this).siblings().children('a').removeClass('active');
            if($(this).parents('.toggle-body').prev('.toggle-head').children('.okdel').css("display")=='none'){
                $(this).children('a').addClass('active').removeClass('dot');
            } else {
                $(this).children('a').addClass('active dot');
            }

            _this.data.industryId = $(this).attr('data-industryid');
            _this.data.libraryId  = $(this).attr('data-id');
            _this.data.leftName = $(this).attr('data-from');
            _this.data.rightName = $(this).attr('data-to');
            _this.data.lanCreateTime = $(this).attr('data-time');
            _this.data.industryName = $(this).parents('.toggle-body').prev('.toggle-head').children('.libraryName').text();
           
            _this.loadRight();
            $('.choosenum').hide();
            $('.delWord').addClass('active');
            $('.daochu').addClass('active');
            _this.data.selectionIds = [];
        })

        // 点击减号收起
        $('body').on('click', '.toggle-head .caret.active', function(e) {
            $(this).removeClass('active');
            $(this).parents(".toggle-head").removeClass("active");
            $(this).parents(".toggle-head").next().slideUp("200");
            $(this).siblings('.delwhat').hide().siblings('.showdown').show();

            e.stopPropagation();
        })

        $('body').on('click', '.toggle-head .delwhat', function(e){
            $(this).hide();
            $(this).siblings(".caret").hide();
            $(this).siblings(".okdel").show();
            $(this).siblings(".del").show();
            $(this).parents().next(".toggle-body").find(".del").show();
            $(this).parents().next(".toggle-body").find("a.active").addClass('dot');

            e.stopPropagation();
        })

        // 点击编辑完成
        $('body').on('click', '.toggle-head .okdel', function() {
            $(this).hide();
            $(this).siblings(".caret").show();
            $(this).siblings(".del").hide();
            $(this).siblings('.delwhat').show();
            $(this).parents().next(".toggle-body").find(".del").hide();
            $(this).parents().next(".toggle-body").find("a.active").removeClass('dot');
        })

        // 点击添加单词
        $('body').on('click', '.kong-add', function(e){
            _this.addWordTip();
        })

        //点击左侧创建术语库
        $('body').on('click', '.create-ku', function(e){
            if(!_comMeds.isLogin()){
                _comMeds.doLogin();
            } else {
                _this.addTermTip();
            }
        })

        //点击左侧新建语言提示
        $('body').on('click', '.add-lei', function(e){
            var param = $(this).parents('.toggle-body').prev('.toggle-head').attr('data-id');
            _this.addLanTip(param);
        })

        // 点击删除整个术语库
        $('body').on('click', '.toggle-head .del', function(e){
            var indId = $(this).parents('.toggle-head').attr('data-id');
            var indName = $(this).siblings('.libraryName').text();
            _this.delHeadTip(indId, indName);
        })

        // 点击删除某个术语库下语言提示
        $('body').on('click', '.toggle-body .del', function(e){
            var param = {
                indId: $(this).parents('dd').attr('data-industryid'),
                libId:  $(this).parents('dd').attr('data-id'),
                F_lan: $(this).parents('dd').attr('data-from'),
                T_lan: $(this).parents('dd').attr('data-to')
            }
            _this.delLanTip(param);
        })

        // 编辑术语
        $('body').on('click', '.update', function(e){
            
            var param = {
                id: $(this).attr('data-id'),
                libraryId: $(this).attr('data-libraryId'),
                originalText: $(this).attr('data-originalText'),
                translateText: $(this).attr('data-translateText'),
                caseType: $(this).attr('data-caseType')
            }
            console.log(param);
            _this.transModify(param);

        })

        // 点击导入术语
        $('body').on('click', '.import-term', function(e){
            _this.importTerm();
        })

        // 点击搜索
        $('#searchBtn').on('click', function() {
            $('#getMyGlossary').DataTable().destroy();
            _this.data.ss = 1;
            _this.getMyGlossary();
        })

        // 回车搜索
        $('#searchStr').keydown(function(e) {
            if(e.keyCode == "13" || e.which == 13) {
                $('#getMyGlossary').DataTable().destroy();
                _this.data.ss = 1;
                _this.getMyGlossary();
            } else {
                return;
            }
        })

         // 点击全选
         $('body').on('click', '.total-check', function(){
            let is_check_all = $(".total-check").prop("checked");
			let choose_id = '';

			if (is_check_all) {
				$(".check-item input").prop("checked",true);
                $.each($(".check-item input"), function (i, item) {
                    console.log(item);
					choose_id = $(item).data("id");
					if ($.inArray(choose_id,_this.data.selectionIds)!=-1) {
						_this.data.selectionIds.splice(choose_id, 1);
					}else{
						_this.data.selectionIds.push(choose_id);
					}
				})
			}else{
				$.each($(".check-item input"),function(i,item){
					choose_id = $(item).data("id");
					let id_index = $.inArray(choose_id,_this.data.selectionIds);
					if (id_index != -1) {
						_this.data.selectionIds.splice(id_index, 1);
					}else{
						_this.data.selectionIds.push(choose_id);
					}
				})
				$(".check-item input").prop("checked",false);
			}
            _this.getCheckbedBoxId();
        })
       
        // 单个点击复选框
        $('body').on('click', '.check-item input', function(){
            let id = $(this).data("id");
			let is_choose = $.inArray(id,_this.data.selectionIds);

			if (is_choose == '-1') {
				_this.data.selectionIds.push(id);
			}else{
				_this.data.selectionIds.splice(is_choose, 1);
            }

            if( $(".total-check").prop("checked") && !$(this).prop('checked')){
                $(".total-check").prop("checked",false);
            }
            
            _this.getCheckbedBoxId();

        })
        

        //点击删除按钮
        $('body').on('click', '.delWord', function() {
            if(_this.data.selectionIds < 1) {
                _comMeds.autoCloseAlert('请至少选择一行');
            } else {
                _this.delMyGlossary();
            }
        })

        // 点击导出按钮
        $('body').on('click', '.daochu', function(){
            if(_this.data.selectionIds < 1) {
                _comMeds.autoCloseAlert('请至少选择一行');
            } else {
                console.log(_this.data.selectionIds)
                _this.exportTerm();
            }
        })

        // 点击全部导出
        $('body').on('click', '.exportall', function() {
            _this.exportAllTerm();
        })

        // 点击下载模板
        $('body').on('click', '.daochumuban', function(){
            _this.excelFormat();
        })

        // 导入术语
        $('.importExcle').on('change', function(){
            if(_this.checkExcel(this.files[0].name)){
                let formData = new FormData();
                formData.append("file",this.files[0]);
                formData.append("deviceType",'web');
                formData.append("deviceId",_comMeds.getDeviceId());
                formData.append('libraryId', _this.data.libraryId);
                formData.append('importType', _this.data.importType);
                _this.data.formData = formData;
                 _this.importTermReq();
            } else {
                _this.importTermTip();
            }
        })
    },

    initSelect: function() {
        //渲染原文下拉框
        let _this = this;
        $('.yuanwen-select').select2({
            data: fromLan,
            minimumResultsForSearch: 1,
            placeholder: "--请选择--",
            width: '100px'
        }).val(_this.data.initFromVal).trigger('change');

        // 渲染译文下拉框
        $('.yiwen-select').select2({
            data: toLan,
            minimumResultsForSearch: 1,
            placeholder: "--请选择--",
            width: '100px',
        }).val(_this.data.initToVal).trigger('change');
    },

    initIndustrySelect: function() {
        // 渲染行业下拉框
    	$(".hangye-select").select2({
    		data:indstryList,
    		minimumResultsForSearch: 1,
    		placeholder: {
                id: indstryList[0].id,
                text: indstryList[0].text
            },
    		width:'240px'
        }).val(1).trigger('change');
    },

    // 添加单词弹框提示
    addWordTip: function() {
        var _this = this;
        var add_word_div = '<div class="tangchuang-box create-term-box">'
                        +'<div class="textaera-box">'
                        +'<textarea class="form-control" rows="5" placeholder="原文" id="oriText"></textarea>'
                        +'<textarea class="form-control" rows="5" placeholder="译文" id="traText"></textarea>'
                        +'<div class="checkbox align-left">'
                        +'<label>'
                        +'<input type="checkbox" id="caseCheck">是否区分大小写'
                        +'</label>'
                        +'</div>'
                        +'</div>'
                    +'</div>';
        _comMeds.zgAlert({
            title: '添加单词',
            width: '450px',
            content: add_word_div,
            yesFn: function(e){
                if($("#oriText").val().trim() == '' || $("#traText").val().trim() == '' ){
                    _comMeds.autoCloseAlert("原文或译文不能为空！");
                    return;
                }
                if(/[<>]/.test($("#oriText").val() || $("#traText").val())){
                    _comMeds.autoCloseAlert("原文或译文不能含有非法字符");
                    return false;
                }
                var subData = {
                    industryId: _this.data.industryId,
                    libraryId: _this.data.libraryId,
                    originalText: $('#oriText').val(),
                    translateText: $('#traText').val(),
                    caseType: $('#caseCheck').prop('checked')
                }
                _term.createGlossary(subData, function(res){
                    $(".common-shadow-bg").remove();
                    _this.getMyGlossary();
                    _this.getIndustryGlossaryCount();
                },function(res){
                    _comMeds.autoCloseAlert(res.msg);
                })
            },
            closeFn: function(e){
                $(".common-shadow-bg").remove();
            }
        })
    },

    // 修改术语弹框
    transModify: function(param) {
        var _this = this;
        var checkCasetype='';

        if(param.caseType == 'true') {
            checkCasetype = 'checked'; 
        } else {
            checkCasetype = '';
        } 

        var add_word_div = '<div class="tangchuang-box create-term-box">'
                        +'<div class="textaera-box">'
                        +'<textarea class="form-control" rows="5" placeholder="原文" id="oriText">'+param.originalText+'</textarea>'
                        +'<textarea class="form-control" rows="5" placeholder="译文" id="traText">'+param.translateText+'</textarea>'
                        +'<div class="checkbox align-left">'
                        +'<label>'
                        +'<input type="checkbox" id="caseCheck" '+ checkCasetype +'>是否区分大小写'
                        +'</label>'
                        +'</div>'
                        +'</div>'
                        +'</div>';
            _comMeds.zgAlert({
                title: '添加单词',
                width: '450px',
                content: add_word_div,
                yesFn: function(e){
                    if($("#oriText").val().trim() == '' || $("#traText").val().trim() == '' ){
                        _comMeds.autoCloseAlert("原文或译文不能为空！");
                        return;
                    }
                    if(/[<>]/.test($("#oriText").val() || $("#traText").val())){
                        _comMeds.autoCloseAlert("原文或译文不能含有非法字符");
                        return false;
                    }
                    var subData = {
                        id: param.id,
                        libraryId: param.libraryId,
                        originalText: $('#oriText').val(),
                        translateText: $('#traText').val(),
                        caseType: $('#caseCheck').prop('checked')
                    }
                    _term.updateGlossary(subData, function(res){
                        $('#getMyGlossary').dataTable().fnDraw(false);
                        $(".common-shadow-bg").remove();
                    },function(res){
                        _comMeds.autoCloseAlert(res.msg);
                    })
                },
                closeFn: function(e){
                    $(".common-shadow-bg").remove();
                }
            })
    },
 
    // 左侧新建语言提示
    addLanTip: function(param) {
        var _this = this;
        var add_tip = '<div class="tanchuang-box create-term-box">'
                    + '<div class="select-item"><span class="title">行业名称: </span>' 
                    + '<select class="hangye-select hangye-select-disabled"></select></div>'
                    + '<div class="select-item"><span class="title">语言方向: </span>' 
                    + '<select class="yuanwen-select" data-placeholder="中文"></select>'
                    + '<i class="iconfont iconjiantouyou"></i>'
                    + '<select class="yiwen-select" data-placeholder="日语"></select>'
                    + '</div>'
                    + '</div>'
            _comMeds.zgAlert({
                title: '新建语言',
                width: '450px',
                content: add_tip,
                yesFn: function(e){
                    var subData = {
                            industryId:  $('.hangye-select option:selected').val(),
                            fromLanguage: fromLan[$('.yuanwen-select option:selected').val()].languageCode,
                            toLanguage: toLan[$('.yiwen-select option:selected').val()].languageCode
                        };
                    _term.createLibrary(subData,function(res){
                        $(".common-shadow-bg").remove();
                        _this.addLanItem(res);
                    },function(res){
                        _comMeds.autoCloseAlert(res.msg);
                    })
                },
                closeFn: function(e){
                    $(".common-shadow-bg").remove();
                },

            })
            _this.initSelect();
            $(".hangye-select").select2({
                data:indstryList,
                minimumResultsForSearch: 1,
                width:'240px',
                "disabled":true
            }).val(param).trigger('change');
            _this.data.leftId = $('.yuanwen-select option:selected').val();
            _this.data.rightId = $('.yiwen-select option:selected').val();

            $('.yuanwen-select').on('select2:select', function(e) {
                let a = fromLan[$(this).val()].languageCode;
                let b = toLan[$('.yiwen-select option:selected').val()].languageCode;
                if(a === b){
                    _comMeds.autoCloseAlert('语言不能相同');
                    $(this).select2('val', "0");
                    return false;
                }
                e.stopPropagation();
            })

            $('.yiwen-select').on('select2:select', function(e) {
                let a = toLan[$(this).val()].languageCode;
                let b = fromLan[$('.yuanwen-select option:selected').val()].languageCode;
                if(a === b){
                    _comMeds.autoCloseAlert('语言不能相同');
                    $(this).select2('val', "1");
                    return false;
                }
                e.stopPropagation();
            })
    },
    // 创建术语库
    addTermTip: function(){
        var _this = this;
        var str = '<div class="tanchuang-box create-term-box">'
            + '<div class="select-item"><span class="title"><i>*</i>行业名称: </span>' 
            + '<select class="hangye-select"></select></div>'
            + '<div class="select-item"><span class="title"><i>*</i>语言方向: </span>' 
            + '<select class="yuanwen-select"></select>'
            + '<i class="iconfont iconjiantouyou"></i>'
            + '<select class="yiwen-select"></select>'
            + '</div>'
            + '</div>';
        _comMeds.zgAlert({
            title: '创建术语库',
            width: '450px',
            content: str,
            yesFn: function(e){
                var tag = 0;
                for(var i = 0; i < _this.data.inIds.length; i++) {
                    if( $('.hangye-select option:selected').val() == _this.data.inIds[i]) {
                        tag = 1;
                        _comMeds.autoCloseAlert('已存在该行业库');
                        return;
                    }
                }

                if(tag == 0) {
                    var subData = {
                        industryId:  $('.hangye-select option:selected').val(),
                        fromLanguage: fromLan[$('.yuanwen-select option:selected').val()].languageCode,
                        toLanguage: toLan[$('.yiwen-select option:selected').val()].languageCode
                    }
                    _term.createLibrary(subData,function(res){
                        _this.data.inIds.push(Number($('.hangye-select option:selected').val()));
                        $(".common-shadow-bg").remove();
                        if($('.left-industry dt').length == 0) {
                            location.reload();
                        } else {
                            _this.addIndItem(res);
                        }
                    },function(res){
                        _comMeds.autoCloseAlert(res.msg);
                    })
                } 
            },
            closeFn: function(e){
                $(".common-shadow-bg").remove();
            }
        })
        _this.initSelect();
        _this.initIndustrySelect();
        _this.data.leftId = $('.yuanwen-select option:selected').val();
        _this.data.rightId = $('.yiwen-select option:selected').val();
        _this.data.currId = $('.hangye-select option:selected').val();
    
        $('.hangye-select').on('change', function() {
            _this.data.currId == $('.hangye-select option:selected').val();
        })

        $('.yuanwen-select').on('select2:select', function(e) {
            let a = fromLan[$(this).val()].languageCode;
            let b = toLan[$('.yiwen-select option:selected').val()].languageCode;
            if(a === b){
                _comMeds.autoCloseAlert('语言不能相同');
                $(this).select2('val', "0");
                return false;
            }
            e.stopPropagation();
        })

        $('.yiwen-select').on('select2:select', function(e) {
            let a = toLan[$(this).val()].languageCode;
            let b = fromLan[$('.yuanwen-select option:selected').val()].languageCode;
            if(a === b){
                _comMeds.autoCloseAlert('语言不能相同');
                $(this).select2('val', "1");
                return false;
            }
            e.stopPropagation();
        })
    },


    //删除整个术语库提示
    delHeadTip: function (indId, indName) {
        console.log(indId, indName);
        var _this = this;
        var del_tip = '<div class="tanchuang-box">'
                    + '<div class="text-box">'
                    + '<p class="tip_text">是否删除整个' + indName +'术语库？</p>'
                    + '<p class="tip_text">删除后整个术语库将无法恢复</p>'
                    + '</div>'
                    + '</div>'
            _comMeds.zgAlert({
                title: '提示',
                width: '430px',
                content: del_tip,
                yesText: '确定',
                noText: '取消',
                yesFn: function(e){
                    $(".common-shadow-bg").remove();
                    _this.delMyIndustry(indId);
                },
                noFn: function(e){
                    $(".common-shadow-bg").remove();
                },
                closeFn: function(e){
                    $(".common-shadow-bg").remove();
                }
            })
    },

    // 删除某个术语库下语言提示
    delLanTip: function (param) {
        console.log(param);
        var _this = this;
        var del_tip = '<div class="tanchuang-box">'
                    + '<div class="text-box">'
                    + '<p class="tip_text">确定删除「' + param.F_lan + '-' + param.T_lan +'」术语库？</p>'
                    + '<p class="tip_text">删除后整个术语库将无法恢复</p>'
                    + '</div>'
                    + '</div>'
            _comMeds.zgAlert({
                title: '提示',
                width: '430px',
                content: del_tip,
                yesText: '确定',
                noText: '取消',
                yesFn: function(e){
                    $(".common-shadow-bg").remove();
                    _this.delMyLibrary(param);
                },
                noFn: function(e){
                    $(".common-shadow-bg").remove();
                },
                closeFn: function(e){
                    $(".common-shadow-bg").remove();
                }
            })
    },

    //导入术语
    importTerm: function() {
        var _this = this;
        $.each(fromLan, function(i, item){
            if(item.text == _this.data.leftName) {
                _this.data.leftId = item.id;
            }
            if(item.text == _this.data.rightName) {
                _this.data.rightId = item.id;
            }
        })
        var add_tip = '<div class="tanchuang-box create-term-box">'
                    + '<div class="select-item"><span class="title">行业名称: </span>' 
                    + '<select class="hangye-select hangye-select-disabled"></select></div>'
                    + '<div class="select-item"><span class="title">语言方向: </span>' 
                    + '<select class="yuanwen-select" data-placeholder="中文"></select>'
                    + '<i class="iconfont iconjiantouyou"></i>'
                    + '<select class="yiwen-select" data-placeholder="日语"></select>'
                    + '</div>'
                    +'<div class="select-item" style="text-align:left;padding-left:38px;">'
                    + '<input type="checkbox" class="importType" />'
                    + '<span style="color:#031B4D;font-size:12px;margin-left:5px;">是否覆盖现有术语</span>'
                    + '</div>'
                    + '</div>'
            _comMeds.zgAlert({
                title: '导入',
                width: '400px',
                content: add_tip,
                yesFn: function(e){
                    $(".common-shadow-bg").remove();
                    $(".importExcle").click();
                },
                closeFn: function(e){
                    $(".common-shadow-bg").remove();
                }
            })

            $(".hangye-select").select2({
                data:indstryList,
                minimumResultsForSearch: 1,
                width: '240px',
                "disabled":true
            }).val(_this.data.industryId).trigger('change');
            $('.yuanwen-select').select2({
                data: fromLan,
                minimumResultsForSearch: 1,
                width:'100px',
                "disabled": true
            }).val(_this.data.leftId).trigger('change');
            $('.yiwen-select').select2({
                data: fromLan,
                minimumResultsForSearch: 1,
                width:'100px',
                "disabled": true
            }).val(_this.data.rightId).trigger('change');

            $('.importType').on('click', function(){
                if($(this).prop('checked')){
                    _this.data.importType = 1;
                } else {
                    _this.data.importType = 0;
                }
            })
    },  

    importTermReq: function() {
       let _this = this;
       var pp = '<div style="width:100%;text-align:center;line-height:24px;">上传中请稍等...<br/>若文件较大时，请多等待些时间</div>';
        var jc = $.dialog({
            title: '',
            boxWidth: '400px',
            useBootstrap: false,
            content: pp,
        })

            $.ajax({
                url: _comMeds.getServerUrl('sdoc/excel/importTerm'),
                type: 'POST',
                dataType: 'json',
                data: _this.data.formData,
                processData: false, // 不处理数据
                contentType: false, // 不设置内容类型
                success: function (data) {
                    if(data.code == 0) {
                        _this.getMyGlossary();
                        _this.getIndustryGlossaryCount();
                       if(data.data.errorMsg){
                           _comMeds.autoCloseAlert(data.data.errorMsg);
                       }
                       if(data.data.errorList.length > 0) {
                           var dd = $.dialog({
                               title: '',
                               boxWidth: '400px',
                               useBootstrap: false,
                               content: '<div class="tangchuang-box create-term-box"><h3>提示</h3>'
                               + '<div class="text-box">'
                               + '<p style="color: #031B4D;font-size: 16px;">成功个数: ' + data.data.successCount + '</p>'
                               + '<p style="color: #031B4D;font-size: 16px;">失败个数: ' + data.data.errorCount + '</p>'
                               + '<div class="err-table"><table id="errTable" class="maintable hover row-border"></table></div>'
                               + '</div>'
                               + '</div>',
                               onContentReady: function () {
                                  $('#errTable').dataTable({
                                    autoWidth:false, // 控制Datatables是否自适应宽度
                                    info: true, // 控制是否显示表格左下角的信息
                                    data: data.data.errorList, //数据
                                    lengthChange:false, // 是否允许用户改变表格每页显示的记录数
                                    lengthMenu:[5], // 显示几项结果
                                    ordering:false, // 是否允许Datatables开启排序
                                    serverSide:false, // 是否开启服务器模式
                                    stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
                                    searching:false, // 是否允许Datatables开启本地搜索
                                    columns: [
                                        {
                                            title:"行数",
                                            data: null,
                                            width:'30%',
                                            className:'align-left',
                                            render: function(data, type, row, meta){
                                                return row.row;
                                            }
                                        },
                                        {
                                            title: '错误信息',
                                            data: null,
                                            width: '70%',
                                            className: 'align-center',
                                            render: function(data, type, row, meta){
                                                return row.msg;
                                            }
                                        }
                                    ],

                                  })
                               }
                           })
                       }
                    } else if(data.code == -1){
                      _comMeds.autoCloseAlert('请求失败');
                    } else if(data.code == -6300012){ // excel文件解析错误
                        _this.importTermTip();
                    } else{
                       _comMeds.autoCloseAlert(data.msg);
                    }
                    $('.importExcle').val(null);
                    _this.data.importType = 0;
                    jc.close();
                },
                error: function(data) {
                    _this.data.importType = 0;
                    $('.importExcle').val(null);
                    _comMeds.autoCloseAlert('请求失败');
                    jc.close();
                    console.log(data);
                    // _this.importTermTip();
                }
            });
    },

    // 导入术语错误提示
    importTermTip: function() {
        var _this = this;
        var tip1_div = '<div class="tangchuang-box  create-term-box">'
                    +'<div style="font-size:16px;color:#031B4D;padding:30px 0;">'
                    +'<p>你上传的文档格式不符合，请下载附件</p>'
                    +'<p>按翻译狗格式填写后，再上传！</p>'
                    +'</div>'
                    +'</div>';
        _comMeds.zgAlert({
            title: '提示',
            width: '400px',
            content: tip1_div,
            yesText: '下载模版',
            yesFn: function(e){
                _this.excelFormat();
                $(".common-shadow-bg").remove();
            },
            closeFn: function(e){
                $(".common-shadow-bg").remove();
            }
        })
    },

    // 下载模板
    excelFormat: function() {
        let url = _comMeds.getServerUrl('sdoc/excel/exportTemplete');
        let form = form =  $("<form style='display:none;' target='' method='post' action="+url+">");
        let input_str = '<input type="hidden" name="deviceType" value="web" />'
					  +'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';
		$("body").append(form);
		form.append(input_str);
        form.submit();
    },

    // 导出术语
    exportTerm: function() {
       let _this = this;
       let url = _comMeds.getServerUrl('sdoc/excel/exportTerm');
        var gids = _this.data.selectionIds.join(',');
        console.log(_this.data.selectionIds);
       let form = form =  $("<form style='display:none;' target='' method='post' action="+url+">");
       let input_str ='<input type="text" style="display:none" name="libraryId" value="'+_this.data.libraryId+'">'
                     +'<input type="text" style="display:none" name="glossaryIds" value="'+gids+'"> '
                     + '<input type="hidden" name="deviceType" value="web" />'
            + '<input type="hidden" name="deviceId" value="' + _comMeds.getDeviceId() + '" />';
        $("body").append(form);
        form.append(input_str);
        form.submit();
    },

    exportAllTerm: function() {
        let _this = this;
        let url = _comMeds.getServerUrl('sdoc/excel/exportTerm');
        var gids = '';
        let form = $("<form style='display:none;' target='' method='post' action="+url+">");
        let input_str ='<input type="text" style="display:none" name="libraryId" value="'+_this.data.libraryId+'">'
                        +'<input type="text" style="display:none" name="glossaryIds" value="'+gids+'"> '
                        + '<input type="hidden" name="deviceType" value="web" />'
                        +'<input type="hidden" name="deviceId" value="'+_comMeds.getDeviceId()+'" />';
        $("body").append(form);
        form.append(input_str);
        form.submit();
    },
    
    // 校验上传格式
    checkExcel: function(objUrl) {
        var obj_url = objUrl.toLowerCase().split('.');
	    if (objUrl == "") {
            return false;
	    } else {
	        if (obj_url[obj_url.length - 1] == 'xls'
	            || obj_url[obj_url.length - 1] == 'xlsx') {
	            return true;
	        } else {
	            return false;
	        }
	    }
    },

    // 显示还未创建术语库
    showEmptyKu: function() {
        $(".kong-content").show();
		$(".right-content").hide();
    },

    // 显示已创建术语库
    showShuyuContent: function() {
        $(".kong-content").hide();
		$(".right-content").show();
    },

    // 获取我的行业库和语言库
    getMyIndustryList: function() {
        let _this = this;
        if(_comMeds.isLogin()){
            _term.getMyIndustryList({}, function(res){
                if(res.length > 0) {
                    _this.showShuyuContent();
                    $(".left-industry").empty();
                    _this.addLeftList(res);
                } else {
                    _this.showEmptyKu();
                }
            })
        } else {
            _this.showEmptyKu();
        }
    },

    // 插入左侧列表
    addLeftList: function(datas) {
        let _this = this;
        var str = '';
        var is_active = '';

        $.each(datas, function(i, item){
            var str_body = '';
            _this.data.inIds[i] = item.id;
            
            $.each(item.libList, function(j, lanItem){
                if( j == '0'){
                    var list_isactive = 'active';
                    if(i == '0') {
                        _this.data.libraryId = lanItem.id;
                        _this.data.industryId = lanItem.industryId;
                        _this.data.leftName = lanItem.fromLanguage;
                        _this.data.rightName = lanItem.toLanguage;
                        _this.data.lanCreateTime = lanItem.createTime;
                        _this.data.industryName = item.chineseName;
                    }
                } else {
                    var list_isactive = '';
                }
                str_body += '<dd data-id="' + lanItem.id + '" data-industryid="' + lanItem.industryId + '" data-from="' + lanItem.fromLanguage + '" data-to="' + lanItem.toLanguage + '" data-time="' + lanItem.createTime + '" >'
                          + '<i class="iconfont iconquxiao del"></i>'
                          + '<a href="javascript:void(0);" class="' + list_isactive + '" >' + lanItem.fromLanguage + '<i class="iconfont iconjiantouyou"></i>' + lanItem.toLanguage + '</a>'
                          + '</dd>'
            })

            if( i == '0') {
                is_active = 'active';
            } else {
                is_active = '';
            }
            
            
            str = '<dt class="toggle-head ' + is_active + '" data-id="' +item.id+ '">'
                + '<i class="caret arrow-up"></i>'
                + '<i class="iconfont iconquxiao del"></i>'
                + '<span class="libraryName">' + item.chineseName + '</span>'
                + '<i class="iconfont iconyoujian showdown"></i>'
                + '<i class="iconfont iconshezhi delwhat"></i>'
                + '<span class="okdel">完成</span>'
                + '</dt>'
                + '<div class="toggle-body toggle-body' + item.id +'">'
                + str_body
                + '<div class="add-lei-wrapper">'
                + '<button class="btn add-lei">'
                + '<i class="iconfont iconxinjianyuyan"></i>'
                + '新建语言</button></div>'
                + '</div>'
            $(".left-industry").append(str);
            $('.toggle-head.active').next().show();
            $('.toggle-head.active').children('.caret').addClass('active');
            $('.toggle-head.active').children('.showdown').hide();
            $('.toggle-head.active').children('.delwhat').show(); 
           
        })
        _this.loadRight();
    },

    // 加载右侧数据
    loadRight: function() {
        let _this = this;

        $("#inName").text(_this.data.industryName);
		$("#fName").text(_this.data.leftName);
        $("#tName").text(_this.data.rightName);
        $("#libTime").text(_comMeds.renderTime(_this.data.lanCreateTime));

        _this.getMyGlossary();

        //获取行业术语总条数
        _this.getIndustryGlossaryCount();
    },

    // 获取行业总条数
    getIndustryGlossaryCount: function() {
        let _this = this;
        var subData = {
            industryId: _this.data.industryId
        }
        _term.getIndustryGlossaryCount(subData, function(res){
            if(res.number == '0') {
                $('#inTotal').text('');
            } else {
                $('#inTotal').text('（ '+res.number+' ）');
            }
        })
    },


    // 插入一项新增的行业
    addIndItem: function(datas) {
       var str = '<dt class="toggle-head" data-id="' +datas.industryId+ '">'
               + '<i class="caret arrow-up"></i>'
               + '<i class="iconfont iconquxiao del"></i>'
               + '<span class="libraryName">' + datas.libraryName + '</span>'
               + '<i class="iconfont iconyoujian showdown"></i>'
               + '<i class="iconfont iconshezhi delwhat"></i>'
               + '<span class="okdel">完成</span>'
               + '</dt>'
               + '<div class="toggle-body toggle-body' + datas.industryId +'"><dd data-id="' + datas.id + '" data-industryid="' + datas.industryId + '" data-from="' + datas.fromLanguage + '" data-to="' + datas.toLanguage + '" data-time="' + datas.createTime + '" ><i class="iconfont iconquxiao del"></i>'
               + '<a href="javascript:void(0);" class="active">' + datas.fromLanguage
               + ' <i class="iconfont iconjiantouyou"></i>' + datas.toLanguage
               + '</a></dd>'
               + '<div class="add-lei-wrapper"><button class="btn add-lei"><i class="iconfont iconxinjianyuyan"></i>新建语言</button></div>'
               + '</div>'
            $('.left-industry').append(str);
    },

    // 插入一项新增的语言
    addLanItem: function(datas) {
        var str = '<dd  data-id="' + datas.id + '" data-industryid="' + datas.industryId + '" data-from="' + datas.fromLanguage + '" data-to="' + datas.toLanguage + '" data-time="' + datas.createTime + '" >'
                +'<i class="iconfont iconquxiao del"></i>'
                +'<a href="javascript:void(0);">'
                + datas.fromLanguage
                + '<i class="iconfont iconjiantouyou"></i>'
                + datas.toLanguage
                +'</a></dd>'
                
        $(".toggle-body"+datas.industryId+" .add-lei-wrapper").before(str);
    },

    // 获取我的术语列表
    getMyGlossary: function() {
        let _this = this;
        let matchIdCount = 0;

        $('.kong-table-content').hide();
        if ($("#getMyGlossary").hasClass("dataTable")) {
            $("#getMyGlossary").dataTable().fnDestroy();
        }

        $('#getMyGlossary').DataTable({
            autoWidth:false, // 控制Datatables是否自适应宽度
            info: true, // 控制是否显示表格左下角的信息
            lengthChange:false, // 是否允许用户改变表格每页显示的记录数
            lengthMenu:[10,20], // 显示几项结果
            ordering:false, // 是否允许Datatables开启排序
            serverSide:true, // 是否开启服务器模式
            dom: 't<"table-bottom-box clearfix"i<"select-page"l>p>',
            stateSave: false, // 保存状态 - 在页面重新加载的时候恢复状态（页码等内容）
            searching:true, // 是否允许Datatables开启本地搜索
            columns: [
                {
					data: null,
					title:'<label class="check-box all-check"><input type="checkbox" name="total-check" class="total-check" /></label>',
					width:'4%',
                    className:'align-left',
					render: function(data, type, row, meta){
                        var content;
                        if($.inArray(row.id,_this.data.selectionIds) != -1){
                            content = '<label class="check-box check-item">'
                                    +'<input type="checkbox" checked name="single-check" data-id="'+row.id+'" />'
                                    +'</label>';
                            matchIdCount++;
                            if (matchIdCount == 10) {
                                $(".total-check").prop("checked",true);
                            }
                        } else {
                            $(".total-check").prop("checked",false);
                            content = '<label class="check-box check-item">'
                                    +'<input type="checkbox" name="single-check" data-id="'+row.id+'" />'
                                    +'</label>';
                        }
                        return content;
					}
				},
                {
                    title:"原文",
                    data: 'originalText',
                    width:'30%',
                    className:'align-left',
                },
                {
                    title:"译文",
                    width:'30%',
                    className:'align-left',
                    data: 'translateText' 
                },
                {
                    title: "是否区分大小写",
                    width: '20%',
                    className: "align-left",
                    data: 'caseType',
                    render: function(data, type, row, meta){
                        if(row.caseType == true) {
                            return '<span>是</span>'
                        } else {
                            return '<span>否</span>'
                        }
                    }
                },
                {
                    title: "操作",
                    className: 'align-left',
                    width: '30%',
                    data: null,
                    render: function(data, type, row, meta) {
                        var str = '<i class="iconfont iconbianji update" style="cursor:pointer;" data-id="'+row.id+'" data-libraryId="' +row.libraryId
                                +'" data-originalText="'+row.originalText+'" data-translateText="'+row.translateText+'" data-caseType="'+row.caseType+'"></i>';
                        return str
                    }
                }
            ],
            ajax: function (data, callback, settings) {
                //封装相应的请求参数，这里获取页大小和当前页码
                var pagesize = data.length;//页面显示记录条数，在页面显示每页显示多少项的时候,页大小
                var start = data.start;//开始的记录序号
                var page = (data.start) / data.length + 1;//当前页码
                var subData = {
                    page:page,
                    libraryId: _this.data.libraryId,
                    searchStr: $('#searchStr').val()
                };

                _term.getMyGlossary(subData, function(res,msg){
                    let returnData = {};
                    matchIdCount = 0;
                    if(_this.data.ss == 0){
                        if (res.total=== 0) {
                            $(".table-bottom-box").hide();
                            $('.kong-table-content').show();
                            $("#getMyGlossary").dataTable().fnDestroy();
                            $("#getMyGlossary").html('');
                            $('#fTotal').text('');
                            return;
                        } else {
                            $('.kong-table-content').hide();
                            $('.btnBox1 .exportall').show();
                            $('#fTotal').text('（ '+res.total+' ）');
                        }
                    } else {
                        _this.data.ss == 0;
                        if(res.total == 0) {
                            $(".table-bottom-box").hide();
                        }
                    }
                    returnData.recordsTotal = res.total;//totalSize指的是总记录数
                    returnData.recordsFiltered = res.total;//后台不实现过滤功能,全部的记录数都需输出到前端，记录数为总数
                    returnData.data = res.list;//返回汽车列表
                    callback(returnData);//这个别忘了！！！
                },function(res){
                    _comMeds.autoCloseAlert(res.msg);
                })
            },
        });
    },

    // 删除单个语言库
    delMyLibrary: function(param) {
        var subData = {
            industryId: param.indId,
            libraryId: param.libId,
            delType: 1
        }
        _term.delMyLibrary(subData, function(res){
           location.reload();
        })
    },

    //删除整个行业库
    delMyIndustry: function(industryId) {
        var subData = {
            industryId: industryId,
            delType: 0
        }
        _term.delMyLibrary(subData, function(res){
            location.reload();
        })
    },

    // 删除我的术语
    delMyGlossary: function() {
        var _this = this;
        var str = '<div style="margin:40px 0;font-size:16px;color:#031B4D;line-height:25px;"><p>已选择'+_this.data.selectionIds.length+'个术语</p><p>是否删除？</p></div>'
        _comMeds.zgAlert({
            title: '提示',
            content: str,
            yesFn: function(e){
                var gids = _this.data.selectionIds.join(',');
                var subData = {
                    glossaryIds: gids,
                    libraryId: _this.data.libraryId
                }
                console.log(subData);
            //    _term.delMyGlossary(subData, function(res){
            //       $('.common-shadow-bg').remove();
            //        _this.getMyGlossary();
            //        _this.getIndustryGlossaryCount();
            //        $('.choosenum').hide();
            //        $('.delWord').addClass('active');
            //        $('.daochu').addClass('active');
            //        _this.data.selectionIds = [];
            //    },function(res){
            //        _comMeds.autoCloseAlert(res.msg)
            //    })
            },
            noFn: function(e){
               $('.common-shadow-bg').remove();
            },
            closeFn: function(e){
               $('.common-shadow-bg').remove();
            },
        })
    },

    getCheckbedBoxId: function() {
        let _this = this;
        if(_this.data.selectionIds.length > 0){
            $('.choosenum').show();
            $('.choosenum').text('已选中'+ _this.data.selectionIds.length+'条内容')
            $('.btnBox1 .delWord').removeClass('active').siblings('.daochu').removeClass('active');
            if(_this.data.selectionIds.length > 1){
                $('.update').fadeOut();
            } else {
                $('.update').fadeIn();
            }
        } else {
            $('.choosenum').hide();
            $('.btnBox1 .delWord').addClass('active').siblings('.daochu').addClass('active');
            $('.update').fadeIn();
        }
    },

    // 清空左右内容内容及相关显示
    emptyLeftAndRight: function() {
        let _this = this;
        _this.data.selectionIds = []; // 选中的列表清空
		$("#searchStr").val(''); // 搜索清空
        $(".left-industry").empty();
        $('.choosenum').hide();

        $(".left-box-header").show();
        $(".btnBox1").show();
        $(".create-ku").show();
        _this.getMyIndustryList();
    },

    // 获取语言
    getLanOptions(){
        let _this = this;
        _tran.getLanguage({},function(res){
            let new_from_lan_arr = [];
            let new_to_lan_arr = [];

            $.each(res.fromList,function(i,item){
                let lan_item = {};
                if (item.languageCode == '' || item.languageCode == 'auto') {
                    return;
                }
                lan_item.id = i;
                lan_item.languageCode = item.languageCode;
                lan_item.text = item.languageName;
                new_from_lan_arr.push(lan_item);
                if (item.languageCode == 'zh') {
                    _this.data.initFromVal = i;
                }

                fromLan = new_from_lan_arr;
            })

            $.each(res.toList,function(i,item){
                let lan_item = {};
                if (item.languageCode == '') {
                    item.languageCode = 0;
                }
                lan_item.id = i;
                lan_item.languageCode = item.languageCode;
                lan_item.text = item.languageName;
                new_to_lan_arr.push(lan_item);
                if (item.languageCode == 'en') {
                    _this.data.initToVal = i;
                }

                toLan = new_to_lan_arr;
            })
        },function(res){
            console.log("获取语言失败");
        })
    }  

}

$(function() {
    page.init();
})
